<template>
    <v-overlay :value="true">
        <v-progress-circular indeterminate size="80">
        </v-progress-circular>
    </v-overlay>
</template>

<script>
    export default {
        name: 'stripe-setup-success',
        async mounted(){
            await this.$store.dispatch( 'stripe/fetchStripeCustomer' )
            this.$router.push({ name: 'clients' })
        }
    }
</script>

<style lang="scss" scoped>

</style>